import useIsAndroid from '@alltrails/core/hooks/useIsAndroid';
import { useExperiments } from '@alltrails/experiments';

// Define treatment variants that suppress interstitials for Android
const TREATMENT_VARIANTS = ['post_auth_app_cta_halfsheet', 'post_auth_app_cta_video_interstitial', 'no_interstitial_app_cta_auth_wall'] as const;

/**
 * Hook for Android-specific interstitial suppression experiment logic
 *
 * Experiment: web-growth-rm-new-interstitial-logic-v6
 *
 * Replaces the pattern:
 * `experiments['web-growth-rm-new-interstitial-logic-v6']?.value !== 'control' && isAndroid`
 *
 * With explicit treatment variant checks.
 */
export default function useV6InterstitialLogic() {
  const isAndroid = useIsAndroid();
  const experiments = useExperiments();

  const experimentValue = experiments['web-growth-rm-new-interstitial-logic-v6']?.value;

  // Check if user is in a treatment variant (not control)
  const isTreatmentVariant = TREATMENT_VARIANTS.includes(experimentValue as any);

  // The corrected Android suppression logic
  const shouldSuppressInterstitialForAndroid = isAndroid && isTreatmentVariant;

  // Individual variant flags (for GoogleOneTap)
  const isHalfsheetVariant = experimentValue === 'post_auth_app_cta_halfsheet';
  const isVideoVariant = experimentValue === 'post_auth_app_cta_video_interstitial';
  const isAuthWallVariant = experimentValue === 'no_interstitial_app_cta_auth_wall';

  return {
    shouldSuppressInterstitialForAndroid,
    isHalfsheetVariant,
    isVideoVariant,
    isAuthWallVariant,
    isPostAuthAppCtaHalfsheetEnabled: isHalfsheetVariant, // Alias for GoogleOneTap
    isPostAuthAppCtaVideoInterstitialEnabled: isVideoVariant // Alias for GoogleOneTap
  };
}
